import { render, staticRenderFns } from "./BellNotification.vue?vue&type=template&id=65ffcee7&scoped=true"
import script from "./BellNotification.vue?vue&type=script&lang=ts"
export * from "./BellNotification.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./BellNotification.vue?vue&type=style&index=0&id=65ffcee7&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "65ffcee7",
  null
  ,true
)

export default component.exports